'use client';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { When } from 'react-if';

import cn from '@/lib/clsxm';

import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import PriceView from '@/components/shared/components/price-view';
import { useDelayedVisibilityOnFocus } from '@/components/shared/components/smart-offers/hooks/useDelayedVisibilityOnFocus';
import useAddToCartHandler from '@/components/shared/helpers/hooks/use-add-to-cart-handler';

import { useSmartOfferStore } from '@/store/smart-offer.store';

import SmartOfferModel from '@/models/smart-offer.model';

export default function SmartInLine({ data }: { data: SmartOfferModel }) {
  const { handleAddToCart, isAddingToCart } = useAddToCartHandler();
  const [showInLine, setShowInLine] = useState(true);

  const handleAddToCartClick = () => {
    handleAddToCart({ data });
  };
  const { showSmartOffer } = useSmartOfferStore();

  const delay = data?.displayDelay ?? 500;
  let isVisible = useDelayedVisibilityOnFocus(delay);
  useEffect(() => {
    if (!showSmartOffer) {
      setShowInLine(false);
    }
  }, [showSmartOffer]);
  return showInLine ? (
    <Container
      className={cn(
        'fixed bottom-2.5 left-0 z-99999999999 flex w-full! flex-col items-center justify-between gap-3 rounded-xl bg-[#FFF5E6] pt-3 pr-4 pb-6 pl-4 transition-opacity transition-transform duration-500 md:h-[87px] md:flex-row md:gap-1 md:pr-3 md:pb-4 md:pl-4 lg:left-[8%] lg:w-[84%]!',
        !isVisible && 'translate-y-full opacity-0',
      )}
    >
      <Container className='flex w-full justify-start! gap-[14px]'>
        <XImage
          width={60}
          height={60}
          src={data?.product?.icon?.publicLink}
          alt={data?.title}
          className='max-h-[210px] rounded-[10px] object-cover object-center'
        />

        <Container>
          <Text semiBold className='line-clamp-1 text-lg leading-[38px] text-[#424244]'>
            {data?.title}
          </Text>
          <Text className='line-clamp-1 text-sm text-[#76767C]'>{data?.description}</Text>
        </Container>
      </Container>
      <Container className='mr-3 ml-3 flex w-full flex-row items-center justify-between gap-6 md:mx-0 md:w-fit md:gap-[44px]'>
        <When condition={data?.product?.price}>
          <Container
            className={clsx(
              data?.product?.discount &&
                data?.product?.discount > 0 &&
                'mr-[42px]! pr-0.5 md:mr-9!',
              'relative w-fit pr-1',
            )}
          >
            <PriceView
              discountLabelClassName=' text-[12px]!  pt-2.5 absolute -right-10 font-normal! top-[15%] mx-auto border-[#FFFFFF] border-[2px] w-9 h-9 shadow-[0px_4px_12px_-5px_#FF7B016E]'
              showDiscountLabel={true}
              key={data?.id}
              price={data?.product?.price}
              lastPrice={data?.product?.lastPrice}
              discount={data?.product?.discount}
              currencyClassName='text-[11px]'
              lastPriceClassName='-mb-2!'
            />
          </Container>
        </When>
        <Container>
          <Button
            className='h-10 w-[140px] min-w-[110px] bg-[#FFB616]! text-[15px] font-normal! transition-colors! duration-500 hover:border-1 hover:border-[#F89406] hover:bg-[#FFF]! hover:text-[#F89406] md:w-fit md:min-w-[140px] md:whitespace-nowrap'
            onClick={handleAddToCartClick}
            isLoading={isAddingToCart}
          >
            {data?.buttonText}
          </Button>
        </Container>
      </Container>
    </Container>
  ) : null;
}
